import AxiosInstance from "../../AxiosInstance";

const BillingbaseUrl = "/operation";
const BillingbaseUrl2 = "/ob/billing";
const BillingbaseUrl3 = "/master";
const BillingbaseUrl4 = "/master/billing";

const BillingService = {
  getnonAudit: (sts) => {
    let Details = {
      importer_iec_no: "-1",
      consignmentNumber: "-1",
      status: sts,
    };
    return AxiosInstance.post(
      BillingbaseUrl + "/getJobNoBasedImpCMNonUploadCL",
      Details
    );
  },
  getAudit: (sts) => {
    let Details = {
      importer_iec_no: "-1",
      consignmentNumber: "-1",
      status: sts,
    };
    return AxiosInstance.post(
      BillingbaseUrl + "/getJobNoBasedImpCMUploadCL",
      Details
    );
  },

  getJobNoBasedImpCMNonUploadCL: (Details) => {
    return AxiosInstance.post(
      BillingbaseUrl + "/getJobNoBasedImpCMNonUploadCL",
      Details
    );
  },

  getJobNoBasedImpCMUploadCL: (Details) => {
    return AxiosInstance.post(
      BillingbaseUrl + "/getJobNoBasedImpCMUploadCL",
      Details
    );
  },
  getJobBasedInvoice: (Details) => {
    return AxiosInstance.post(BillingbaseUrl2 + "/getJobBasedInvoice", Details);
  },
  getJobBasedItem: (Details) => {
    return AxiosInstance.post(BillingbaseUrl2 + "/getJobBasedItem", Details);
  },
  UploadBilling: (Details) => {
    return AxiosInstance.put(BillingbaseUrl2 + "/UploadBilling", Details);
  },
  updateQuery: (Details) => {
    return AxiosInstance.put(BillingbaseUrl2 + "/updateQuery", Details);
  },
  getConsignmentJobEntryAssign: (Details) => {
    return AxiosInstance.post(
      BillingbaseUrl2 + "/getConsignmentJobEntryAssign",
      Details
    );
  },
  getConsignmentJobEntryAssignExport: (Details) => {
    return AxiosInstance.post(
      BillingbaseUrl2 + "/getConsignmentJobEntryAssignExport",
      Details
    );
  },
  // console bill
  getImporterDetails: () => {
    return AxiosInstance.get(BillingbaseUrl3 + "/getImporterDetails");
  },

  getbillName: (billType) => {
    return AxiosInstance.get(
      BillingbaseUrl2 + "/getbillName?billType=" + billType
    );
  },
  getBillPaymentType: () => {
    return AxiosInstance.get(BillingbaseUrl2 + "/getBillPaymentType");
  },
  getBillPaidBy: () => {
    return AxiosInstance.get(BillingbaseUrl2 + "/getBillPaidBy");
  },
  getVoucherType: () => {
    return AxiosInstance.get(BillingbaseUrl2 + "/getVoucherType");
  },
  getBillPaidTo: () => {
    return AxiosInstance.get(BillingbaseUrl2 + "/getBillPaidTo");
  },
  getPrintedType: () => {
    return AxiosInstance.get(BillingbaseUrl2 + "/getPrintedType");
  },
  insertBilling: (details) => {
    return AxiosInstance.post(BillingbaseUrl2 + "/insertBilling", details);
  },
  updateBilling: (details) => {
    return AxiosInstance.put(BillingbaseUrl2 + "/updateBilling", details);
  },
  getBilling: (consignmentId, billType) => {
    return AxiosInstance.get(
      BillingbaseUrl2 +
        "/getBilling?consignmentId=" +
        consignmentId +
        "&billType=" +
        billType
    );
  },
  deleteBilling: (billId) => {
    return AxiosInstance.delete(
      BillingbaseUrl2 + "/deleteBilling?billId=" + billId
    );
  },
  opgetConsignmentJobEntryAssign: (consignmentId) => {
    return AxiosInstance.get(
      BillingbaseUrl +
        "/getConsignmentJobEntryAssign?consignmentId=" +
        consignmentId
    );
  },
  // getJobDetailsAssign(consignmentId){
  //     return AxiosInstance.get(BillingbaseUrl+'/getJobDetailsAssign?consignmentId='+consignmentId);
  // }

  //1stlvl
  getBillingQuotationDetails: (consignmentId) => {
    return AxiosInstance.get(
      BillingbaseUrl2 +
        "/getBillingQuotationDetails?consignmentId=" +
        consignmentId
    );
  },
  //2nd
  getBillingCustodian: (consignmentId, billType) => {
    return AxiosInstance.get(
      BillingbaseUrl2 +
        "/getBillingCustodian?consignmentId=" +
        consignmentId +
        "&billType=" +
        billType
    );
  },
  getPaymentReqPurpose: (details) => {
    return AxiosInstance.post(
      BillingbaseUrl2 + "/getPaymentReqPurpose",
      details
    );
  },
  getAllPayment: (consignmentId, billType) => {
    return AxiosInstance.get(
      BillingbaseUrl +
        "/getAllPayment?consignmentId=" +
        consignmentId +
        "&billType=" +
        billType
    );
  },
  getBillingCustom: (consignmentId, billType) => {
    return AxiosInstance.get(
      BillingbaseUrl2 +
        "/getBillingCustom?consignmentId=" +
        consignmentId +
        "&billType=" +
        billType
    );
  },
  getBillingSummary: (consignmentId) => {
    return AxiosInstance.get(
      BillingbaseUrl2 + "/getBillingSummary?consignmentId=" + consignmentId
    );
  },
  update1stLevelVerification: (details) => {
    return AxiosInstance.put(
      BillingbaseUrl2 + "/update1stLevelVerification",
      details
    );
  },
  deletedOverAllBilling: (billId) => {
    return AxiosInstance.delete(
      BillingbaseUrl2 + "/deletedOverAllBilling?billId=" + billId
    );
  },
  getJobDetailsOperationTypeBillPreview: (consignmentNumber) => {
    return AxiosInstance.get(
      BillingbaseUrl +
        "/getJobDetailsOperationTypeBillPreview?consignmentNumber=" +
        consignmentNumber
    );
  },
  getJobDetailsBasedonOperationType: (consignmentNumber) => {
    return AxiosInstance.get(
      BillingbaseUrl +
        "/getJobDetailsBasedonOperationType?consignmentNumber=" +
        consignmentNumber
    );
  },
  getRegionalOfficeDetails: () => {
    return AxiosInstance.get(BillingbaseUrl3 + "/getRegionalOfficeDetails");
  },
  updateJobBillPreview: (details) => {
    return AxiosInstance.post(
      BillingbaseUrl + "/updateJobBillPreview",
      details
    );
  },

  getQuotationBasedOnCustomerType: (details) => {
    return AxiosInstance.post(
      BillingbaseUrl4 + "/getQuotationBasedOnCustomerType",
      details
    );
  },
  insertQuotationToBillingTariff: (details) => {
    return AxiosInstance.post(
      BillingbaseUrl + "/insertQuotationToBillingTariff",
      details
    );
  },
  getJobWeight: (Flag, consignmentId) => {
    return AxiosInstance.get(
      BillingbaseUrl +
        "/getJobWeight?Flag=" +
        Flag +
        "&consignmentId=" +
        consignmentId
    );
  },

  updateChargableWeight: (details) => {
    return AxiosInstance.put(
      BillingbaseUrl + "/updateChargableWeight",
      details
    );
  },
  getJobDetailsAssign: (consignmentId) => {
    return AxiosInstance.get(
      BillingbaseUrl + "/getJobDetailsAssign?consignmentId=" + consignmentId
    );
  },
  getBillingGovtStaff: (consignmentId, billType) => {
    return AxiosInstance.get(
      BillingbaseUrl2 +
        "/getBillingGovtStaff?consignmentId=" +
        consignmentId +
        "&billType=" +
        billType
    );
  },
  getBillingShippingLine: (consignmentId, billType) => {
    return AxiosInstance.get(
      BillingbaseUrl2 +
        "/getBillingShippingLine?consignmentId=" +
        consignmentId +
        "&billType=" +
        billType
    );
  },
  getBillingAirlines: (consignmentId, billType) => {
    return AxiosInstance.get(
      BillingbaseUrl2 +
        "/getBillingAirlines?consignmentId=" +
        consignmentId +
        "&billType=" +
        billType
    );
  },
  getBillingTransporter: (consignmentId, billType) => {
    return AxiosInstance.get(
      BillingbaseUrl2 +
        "/getBillingTransporter?consignmentId=" +
        consignmentId +
        "&billType=" +
        billType
    );
  },
  getBillingForwarder: (consignmentId, billType) => {
    return AxiosInstance.get(
      BillingbaseUrl2 +
        "/getBillingForwarder?consignmentId=" +
        consignmentId +
        "&billType=" +
        billType
    );
  },

  update2ndLevelVerification: (details) => {
    return AxiosInstance.put(
      BillingbaseUrl2 + "/update2ndLevelVerification",
      details
    );
  },
  //billsubmission
  getEmployeeDetails: () => {
    return AxiosInstance.get(BillingbaseUrl2 + "/getEmployeeDetails");
  },
  updateBillSubmission: (details) => {
    return AxiosInstance.put(BillingbaseUrl + "/updateBillSubmission", details);
  },
  getBillSubmission: (consignmentId) => {
    return AxiosInstance.get(
      BillingbaseUrl + "/getBillSubmission?consignmentId=" + consignmentId
    );
  },

  insertQuotationBillingFundAmount: (details) => {
    return AxiosInstance.post(
      BillingbaseUrl2 + "/b_insert_quotation_billing_fund_amount",
      details
    );
  },
};

export default BillingService;
